export default "__VITE_ASSET__B6_5lAGq__"